import api from '../../../services/api';
import type { AxiosProgressEvent } from 'axios';

export const uploadEndpoints = {
  sales_order: '/api/fc_sales_order/upload_file',
  sellin: '/api/fc_sellin/upload_file',
  ats: '/api/fc_ats/upload_file',
};

export const uploadFile = async (
  file: File,
  type: keyof typeof uploadEndpoints,
  token: string | null,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
) => {
  const formData = new FormData();
  formData.append('file', file);

  const endpoint = uploadEndpoints[type];

  const res = await api.post(endpoint, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
    onUploadProgress,
  });

  return res;
};
